export default __webpack_public_path__ + "static/media/post3.304748fa.jpg";